import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Input } from "@/components/ui/Input";
import { Select } from "@/components/ui/Select";
import { Button } from "@/components/ui/Button";
import type { TarefaRecorrenciaFreq } from "@/services/tarefas";
import type { RecorrenciaFormState } from "./recorrenciaUtils";

interface ModalRecorrenciaCustomProps {
  open: boolean;
  initial: RecorrenciaFormState;
  onClose: () => void;
  onSave: (form: RecorrenciaFormState) => void;
}

const FREQ_OPTIONS: Array<{ value: TarefaRecorrenciaFreq; label: string }> = [
  { value: "daily", label: "Dia(s)" },
  { value: "weekly", label: "Semana(s)" },
  { value: "monthly", label: "Mês(es)" },
  { value: "yearly", label: "Ano(s)" },
  { value: "weekdays", label: "Dias úteis (seg–sex)" },
];

export function ModalRecorrenciaCustom({
  open,
  initial,
  onClose,
  onSave,
}: ModalRecorrenciaCustomProps) {
  const [form, setForm] = useState(initial);

  useEffect(() => {
    if (open) setForm(initial);
  }, [open, initial]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Recorrência personalizada"
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onSave({ ...form, preset: "custom" });
              onClose();
            }}
          >
            Aplicar
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <Input
            label="A cada"
            type="number"
            min={1}
            max={99}
            value={String(form.interval)}
            onChange={(e) =>
              setForm((f) => ({ ...f, interval: Math.max(1, Number(e.target.value) || 1) }))
            }
          />
          <Select
            label="Período"
            value={form.freq === "none" ? "daily" : form.freq}
            onChange={(e) =>
              setForm((f) => ({ ...f, freq: e.target.value as TarefaRecorrenciaFreq }))
            }
            options={FREQ_OPTIONS.map((o) => ({ value: o.value, label: o.label }))}
          />
        </div>
        <Input
          label="Terminar em (opcional)"
          type="date"
          value={form.until}
          onChange={(e) => setForm((f) => ({ ...f, until: e.target.value }))}
        />
      </div>
    </Modal>
  );
}
